<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.family.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.family.list.title"></app-i18n>
      </h1>

      <app-family-list-toolbar :subpropertyId="subpropertyId"></app-family-list-toolbar>
      <app-family-list-filter :subpropertyId="subpropertyId"></app-family-list-filter>
      <app-family-list-table  :subpropertyId="subpropertyId"></app-family-list-table>
    </div>
  </div>
</template>

<script>
import FamilyListFilter from '@modules/family/components/family-list-filter.vue';
import FamilyListTable from '@modules/family/components/family-list-table.vue';
import FamilyListToolbar  from '@modules/family/components/family-list-toolbar.vue';

export default {
  name: 'app-family-list-page',
  props: {
    subpropertyId: {
      type: String,
      required: true
    }
  },
  components: {
    [FamilyListFilter.name]: FamilyListFilter,
    [FamilyListTable.name]: FamilyListTable,
    [FamilyListToolbar.name]: FamilyListToolbar,
  },
};
</script>

<style>
</style>
